import Debugger from "./console/debugger";
import BookData from "./book_data";
import BasePageLoader from "./page_loader/base_page_loader";
import { enableAntialiasing } from "./debug_setting";
import EventBus from "./event_bus";
import { settingStore } from "./store/settingStore";
import PainterProxy from "./painter/proxy";
import { store, originBookSize } from '../store';
import { PAGE_TAG } from "./page_loader/page_tag";
import SystemData from "./system_data";
import { VIEW_TYPE, WEB_BROWSER } from "./view_type";
import SVGConverterTask from "./svg_converter/svg_converter_task";
import { CONVERTER_TYPE } from "./svg_converter/converter_define";

export default class PageLoader extends BasePageLoader {
    type = "pageLoader";

    AdobeAn = null;
    createjs = null;

    fnStartAnimation = null;

    pageContainers = [];
    nowPages = [];
    nowPageNames = [];
    loadPageProgress = 0;

    instance = null;

    //pageCompositionMap = new Map();
    // resourceMap = new Map();

    initFinishCallback = null;

    prePoint = null;

    moveTarget = null;

    onStageResize = null;

    fullPngPage = null;
    svgPageUrls = [];
    pageBackgrounds = [];
    pageTextBackgrounds = [];
    blurPageBackgrounds = [];

    pageCanvas = null;
    pageStage = null;
    anim_container = null;
    dom_overlay_container = null;
    preloaderDiv = null;

    antialiasingMovieClips = []; //動態做反鋸齒的物件

    itemControl = null;

    startFrame = 0; //載入完成後會直接跳到哪個起始影格

    stageWidth = 0;
    stageHeight = 0;

    loadBlur = true;

    isLoadNewPage = false;

    startLoadPageTime = 0;
    checkTime = 0;

    constructor() {
        super();
        this.initNeedScript();
    }

    initNeedScript() {
        let self = this;
        PageLoader.instance = this;

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.onload = function () {
            Debugger.Instance.log('load finish', "page_loader");
            if (typeof self.initFinishCallback == "function") {
                self.initFinishCallback();
            }
        }
        try {
            if (SystemData.Instance.getPlatform() !== 'darwin') {
                script.src = './createjs.min.js';
            } else {
                script.src = '../app/createjs.min.js';
            }
            document.getElementsByTagName("head")[0].appendChild(script);
        } catch (error) {
            Debugger.Instance.log(`err: ${error}`, "page_loader");
        }

        this.initPageContainers();
    }

    initPageContainers() {
        for (let i = 0; i < 2; i++) {
            let page = {
                canvas: null,
                stage: null,
                exportRoot: null,
                anim_container: null,
                dom_overlay_container: null,
                comp: null
            };

            this.pageContainers.push(page);
        }
        this.pageCanvas = document.getElementById("canvas");
        this.pageCanvas.style.display = 'block';

        this.anim_container = document.getElementById("animation_container");
        this.dom_overlay_container = document.getElementById("dom_overlay_container");

        this.pageBackgrounds.push(document.getElementById("left-page-svg"));
        this.pageBackgrounds.push(document.getElementById("right-page-svg"));

        this.pageTextBackgrounds.push(document.getElementById("left-page-svg-text"));
        this.pageTextBackgrounds.push(document.getElementById("right-page-svg-text"));

        this.blurPageBackgrounds.push(document.getElementById("left-page-loading"));
        this.blurPageBackgrounds.push(document.getElementById("right-page-loading"));

        this.fullPngPage = document.getElementById("full-png-page");

        // 新增頁面轉換器
        if (store.onlyRead) {
            SVGConverterTask.Instance.add(CONVERTER_TYPE.PAGE, this.fullPngPage, 1583, 1017);
        } else {
            SVGConverterTask.Instance.add(CONVERTER_TYPE.PAGE, this.fullPngPage, 1457, 936);
        }
    }

    loadNewPage(urls) {
        const self = this;

        Debugger.Instance.log({ "urls": urls }, "page_loader");
        this.itemControl.clearItems();
        window.currentPageItemControl = this.itemControl;
        this.antialiasingMovieClips = [];


        if (this.pageBackgrounds[0] && this.pageBackgrounds[1]) {
            while (this.pageBackgrounds[0].hasChildNodes()) {
                this.pageBackgrounds[0].removeChild(this.pageBackgrounds[0].firstChild);
            }
            while (this.pageBackgrounds[1].hasChildNodes()) {
                this.pageBackgrounds[1].removeChild(this.pageBackgrounds[1].firstChild);
            }
        }

        if (this.fullPngPage) {
            while (this.fullPngPage.hasChildNodes()) {
                this.fullPngPage.removeChild(this.fullPngPage.firstChild);
            }
        }

        if (this.pageTextBackgrounds[0] && this.pageTextBackgrounds[1]) {
            while (this.pageTextBackgrounds[0].hasChildNodes()) {
                this.pageTextBackgrounds[0].removeChild(this.pageTextBackgrounds[0].firstChild);
            }
            while (this.pageTextBackgrounds[1].hasChildNodes()) {
                this.pageTextBackgrounds[1].removeChild(this.pageTextBackgrounds[1].firstChild);
            }
        }

        if (this.pageContainers.length > 0) {
            this.pageContainers.forEach(container => {
                container.exportRoot = null;
            })
        }
        if (this.pageStage != null) {
            this.pageStage.removeAllChildren();
        }
        this.nowPages = urls;
        // this.nowPageNames = pageNames;
        this.loadPageProgress = 0;

        this.startLoadPageTime = new Date().getTime();

        if (this.loadBlur) {
            // TODO:模擬網路不穩時，顯示模糊圖。
            EventBus.getInstance().getAppRefs().bookPage.isLoading = true;

            this.blurPageBackgrounds[0].src = `${BookData.Instance.getNowBookPath() + this.nowPages[0] + ".jpg"}`;
            this.blurPageBackgrounds[1].src = `${BookData.Instance.getNowBookPath() + this.nowPages[1] + ".jpg"}`;

            let times = 2;


            //self.pageBackgrounds[0].style.visibility = 'hidden';
            //self.pageBackgrounds[1].style.visibility = 'hidden';
            // EventBus.getInstance().getAppRefs().bookPage.clearLoadingAnim();

            let loadSuccess = function () {
                times--;

                if (times == 0) {
                    self.fullPngPage.style.visibility = 'visible';
                    self.pageBackgrounds[0].style.visibility = 'visible';
                    self.pageBackgrounds[1].style.visibility = 'visible';
                    //EventBus.getInstance().getAppRefs().bookPage.loadingOpacity = 0;

                    for (let i = 0; i < self.pageBackgrounds.length; i++) {
                        self.pageBackgrounds[i].data = "";
                    }

                    if (self.loadPageTimer != null) {
                        clearTimeout(self.loadPageTimer);
                    }

                    self.loadPageTimer = setTimeout(() => {
                        EventBus.getInstance().getAppRefs().bookPage.isLoading = false;
                        self.loadPage();
                        self.checkTime = self.startLoadPageTime;
                    });
                }

            }

            let loadFailed = function (e, index) {
                self.blurPageBackgrounds[index].src = `${BookData.Instance.getNowBookPath() + "blur.jpg"}`;
            }

            this.blurPageBackgrounds[0].onload = loadSuccess;
            this.blurPageBackgrounds[1].onload = loadSuccess;
            this.blurPageBackgrounds[0].onerror = (e) => { loadFailed(e, 0); };
            this.blurPageBackgrounds[1].onerror = (e) => { loadFailed(e, 1); };
        } else {
            this.loadPage();
        }
    }

    loadPageByView(offsetX, offsetY, scale) {
        SVGConverterTask.Instance.set(CONVERTER_TYPE.PAGE, { offsetX, offsetY, scale });
    }

    loadPage() {
        let self = this;
        var script = document.createElement("script");
        script.type = "text/javascript";

        this.loadBackground();
        let isLoadFromCache = false;
        let findNew = false;

        try {
            script.onload = function () {
                self.createjs = window.createjs;
                self.AdobeAn = window.AdobeAn;

                let compositions = Object.keys(window.AdobeAn.compositions);
                let compositionArray = Array.from(window.compositionMap.values());

                for (let i = 0; i < compositions.length; i++) {
                    if (compositionArray.indexOf(compositions[i]) == -1) {
                        self.currentComposition = compositions[i];
                        console.log(`window.compositionMap.set(${self.nowPages[self.loadPageProgress]}, ${compositions[i]});`)
                        window.compositionMap.set(self.nowPages[self.loadPageProgress], compositions[i]);
                        self.startLoad(compositions[i]);
                        findNew = true;
                        i = compositions.length;
                    }
                }

                if (!isLoadFromCache && !findNew) {
                    console.error("有重複的id",)
                }


                if (window.AdobeAn == null || self.createjs == null) {
                    throw "AdobeAn or createjs load fail.";
                }
            }

            script.onerror = function () {
                self.onLoadPageError();
            }

            if (!window.compositionMap.has(self.nowPages[self.loadPageProgress])) {
                Debugger.Instance.log("沒有讀取過頁面資料重新讀取", "page_loader");
                // script.src = BookData.Instance.getNowBookPath() + self.nowPages[self.loadPageProgress] + ".js";
                script.src = this.fixLoadPath(self.nowPages[self.loadPageProgress]);
                document.getElementsByTagName("head")[0].appendChild(script);
                isLoadFromCache = false;
            } else {
                Debugger.Instance.log("已經讀取過資料了，直接從compositions中取資料", "page_loader")
                window.AdobeAn = window.AdobeAn;
                self.createjs = window.createjs;
                let composition = window.compositionMap.get(self.nowPages[self.loadPageProgress]);
                self.startLoad(composition);
                isLoadFromCache = true;
            }
        } catch (error) {
            console.error(`err: ${error}`);
        }
    }

    loadBackground() {
        const url = BookData.Instance.getNowBookPath() + this.nowPages[this.loadPageProgress] + ".svg";
        const page = this.loadPageProgress;

        this.loadSvgToBackground(url, page);

        this.svgPageUrls[page] = url;

        // 僅ios或web(safari)的情況下要使用轉換功能
        if (store.nowView == VIEW_TYPE.IOS || (store.nowView == VIEW_TYPE.WEB && store.nowWebBrowser == WEB_BROWSER.SAFARI)) {
            if (this.svgPageUrls.length == 2) {
                this.loadSvgData();
            }
        }

        this.loadSvgText(BookData.Instance.getNowBookPath() + this.nowPages[this.loadPageProgress] + "_t.svg", this.loadPageProgress);
    }

    loadSvgData() {
        SVGConverterTask.Instance.set(CONVERTER_TYPE.PAGE, { url: this.svgPageUrls })

        this.svgPageUrls = [];
    }

    async loadSvgToBackground(url, page) {
        await fetch(url)
            .then(response => response.text())
            .then(svg => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(svg, "image/svg+xml");
                this.overrideImgResource(doc.getElementsByTagName('defs').item(0).getElementsByTagName('image'));
                // override defs
                const defs = doc.getElementsByTagName('defs').item(0).children;
                for (let j = 0; j < defs.length; j++) {
                    this.overrideUse(defs.item(j), doc)
                }

                this.overrideTagsId(this.uniqueTags, doc);
                if (page == 0) {
                    doc.documentElement.setAttribute("width", "3688px");
                    doc.documentElement.setAttribute("viewBox", "0 0 3688 2369");
                }
                this.pageBackgrounds[page].append(doc.documentElement);
            })
            .catch(error => {
                console.error("讀取svgBackground失敗！", error);
            })
    }

    async loadSvgText(url, page) {
        await fetch(url)
            .then(response => response.text())
            .then(svg => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(svg, "image/svg+xml");
                this.overrideImgResource(doc.getElementsByTagName('defs').item(0).getElementsByTagName('image'));
                // override defs
                const defs = doc.getElementsByTagName('defs').item(0).children;
                for (let j = 0; j < defs.length; j++) {
                    this.overrideUse(defs.item(j), doc)
                }

                this.overrideTagsId(this.uniqueTags, doc);
                if (page == 0) {
                    doc.documentElement.setAttribute("width", "3688px");
                    doc.documentElement.setAttribute("viewBox", "0 0 3688 2369");
                }
                this.pageTextBackgrounds[page].append(doc.documentElement);
            })
            .catch(error => {
                console.error("讀取svgText失敗！", error);
            })
    }

    /**
     * 
     * @param {HTMLCollectionOf<SVGImageElement>} nodes 
     */
    overrideImgResource(nodes) {
        console.log("store.nowBook::", store.nowBook);
        for (let i = 0; i < nodes.length; i++) {
            const newImgSrc = BookData.Instance.getBookContentPath() + `${store.nowBook}/` + nodes.item(i).getAttribute("xlink:href");
            // imgs.item(0).setAttribute("xlink:href", newImgSrc)
            nodes.item(i).setAttribute("xlink:href", newImgSrc);
        }
    }
    /**
     * 
     * @param {HTMLCollectionOf<SVGImageElement>} nodes 
     */
    modifyLeftPage() {

    }

    /**
     * start load composition
     * @param {string} composition
     */
    startLoad(composition) {
        let self = this;
        // var comp = window.AdobeAn.getComposition(window.compositionMap.get(self.nowPages[self.loadPageProgress]));
        var comp = window.AdobeAn.getComposition(composition);

        if (this.preloader) {
            this.preloader.removeAllEventListeners();
            this.preloader.close();
            this.preloader.destroy();
        }

        var lib = comp.getLibrary();
        var loader = new this.createjs.LoadQueue(false);
        this.preloader = loader;
        loader.addEventListener("fileload", function (evt) { this.handleFileLoad(evt, comp) }.bind(this));
        loader.addEventListener("complete", function (evt) { this.handleComplete(evt, comp) }.bind(this));

        let loadmanifest = lib.properties.manifest.filter(item => {
            return !window.resourceMap.has(item.id)
        });

        let fixedSrc = this.fixManifestPath(loadmanifest);

        Debugger.Instance.log({ 'loadmanifest': loadmanifest }, "page_loader");

        loader.loadManifest(fixedSrc);

        // 如果該頁面沒有按鈕，立刻執行縮放比例等相關設定
        if (fixedSrc.length == 0) {
            var evt = {
                target: null
            }
            this.handleComplete(evt, comp);
        }
    }
    fixManifestPath(manifest) {
        let manifestPath = JSON.parse(JSON.stringify(manifest));
        let fixedPath = manifestPath.map(item => {
            item.crossOrigin = "Anonymous";
            if (item.src.indexOf("https://") == -1) {
                if (item.src.indexOf(".png") != -1) {
                    item.src = BookData.Instance.getNowBookPath() + item.src;
                }
                if (item.src.indexOf(BookData.Instance.getBookPath()) == -1) {
                    item.src = BookData.Instance.getBookPath() + item.src;
                }
            }
            if (item.src.indexOf("jquery") != -1) {
                if (SystemData.Instance.getPlatform() !== 'darwin') {
                    item.src = "./jquery-3.4.1.min.js";
                } else {
                    item.src = "../app/jquery-3.4.1.min.js";
                }
            }

            return item;
        })

        return fixedPath;
    }

    fixLoadPath(path) {
        if (path != "empty") {
            return BookData.Instance.getNowBookPath() + path + ".js";
        } else {
            return "./empty.js";
        }
    }

    handleFileLoad(evt, comp) {
        var images = comp.getImages();
        if (evt && (evt.item.type == "image")) {
            images[evt.item.id] = evt.result;
            //window.resourceMap.set(evt.item.id, evt.item.src);
        }
        if (evt && (evt.item.type == "javascript")) {
            // Debugger.Instance.log(evt.item)
            window.resourceMap.set(evt.item.id, evt.item.src);
        }
    }
    handleComplete(evt, comp) {
        //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
        var lib = comp.getLibrary();
        var ss = comp.getSpriteSheet();
        var queue = evt.target;
        var ssMetadata = lib.ssMetadata;
        let i = 0;
        for (i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new this.createjs.SpriteSheet({ "images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames })
        }
        var preloaderDiv = document.getElementById("preload_div_");
        preloaderDiv.style.display = 'none';

        let pageName = this.nowPages[this.loadPageProgress].split('.js')[0];
        Debugger.Instance.log({ 'pageName': pageName }, "page_loader");
        console.log("lib:", lib);
        console.log(pageName);
        // this.pageContainers[this.loadPageProgress].canvas.style.display = 'block';
        this.pageContainers[this.loadPageProgress].exportRoot = new lib[pageName];
        this.pageContainers[this.loadPageProgress].exportRoot.tag = PAGE_TAG.PAGE;
        this.pageContainers[this.loadPageProgress].exportRoot.pageName = window.pageControl.getNowPageNames()[this.loadPageProgress];
        if (this.pageStage == null) {
            this.pageStage = new this.createjs.Stage(this.pageCanvas);
            this.pageStage.mouseEnabled = false;
            this.pageStage.enableMouseOver();
            this.pageStage.addEventListener("click", (e) => {
                console.log("e", e);
            })
            window.stage = this.pageStage;
            this.createjs.Ticker.addEventListener("tick", this.antialiasingObjects.bind(this));
        }
        //this.pageContainers[this.loadPageProgress].stage = new lib.Stage(this.pageContainers[this.loadPageProgress].canvas);
        // this.pageContainers[this.loadPageProgress].stage.enableMouseOver();
        this.pageContainers[this.loadPageProgress].comp = comp;


        //Registers the "tick" event listener.
        this.fnStartAnimation = function () {
            //TODO:這邊會重複把child add進pageStage, 目前先限制只能add 2個children.
            if (this.pageStage.numChildren < 2) {
                this.pageStage.addChild(this.pageContainers[this.loadPageProgress].exportRoot);
            }
            this.pageContainers[this.loadPageProgress].exportRoot.x = this.loadPageProgress * lib.properties.width;
            this.pageContainers[this.loadPageProgress].exportRoot.gotoAndStop(this.startFrame);
            // this.pageContainers[this.loadPageProgress].exportRoot.visible = false;
            this.createjs.Ticker.framerate = lib.properties.fps;
            console.log("add tick listener");

            this.createjs.Ticker.addEventListener("tick", this.pageStage);
            //this.loadBackground();


            if (this.loadPageProgress == 1) {
                this.onPageStageInit();
                store.canTurnPage = true;
                this.itemControl.countdownInitBookItems();
            }
        }

        //Code to support hidpi screens and responsive scaling.
        window.AdobeAn.makeResponsive = this.makeResponsive.bind(this);
        window.AdobeAn.makeResponsive(true, 'both', true, 1, this.pageStage, lib, [this.pageCanvas, preloaderDiv, this.anim_container, this.dom_overlay_container]);

        window.AdobeAn.compositionLoaded(lib.properties.id);
        // window.compositionMap.set(this.nowPages[this.loadPageProgress], lib.properties.id)

        this.fnStartAnimation();

        if (this.loadPageProgress == 0) {
            this.loadPageProgress = 1;
            this.loadPage();
        }
    }

    makeResponsive(isResp, respDim, isScale, scaleType, stage, lib, domContainers) {
        let self = this;
        window.addEventListener('resize', () => {
            // self.scaleCanvas(lib);
            self.resizeCanvas(isResp, respDim, isScale, scaleType, stage, lib, domContainers);
        });
        this.resizeCanvas(isResp, respDim, isScale, scaleType, stage, lib, domContainers);
    }
    scaleCanvas() {
        let iw = window.pageWidth, ih = window.pageHeight;
        store.setBookPageScale(iw / originBookSize.width, ih / originBookSize.height);
    }
    resizeCanvas(isResp, respDim, isScale, scaleType, stage, lib, domContainers) {
        var lastW, lastH, lastS = 1;
        var w = lib.properties.width * 2, h = lib.properties.height;
        this.stageWidth = w;
        this.stageHeight = h;
        EventBus.getInstance()._app.updatePageSize();
        var iw = originBookSize.width, ih = originBookSize.height;
        var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;

        if (isResp) {
            if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                sRatio = lastS;
            }
            else if (!isScale) {
                if (iw < w || ih < h) {
                    sRatio = Math.min(xRatio, yRatio);
                }
            }
            else if (scaleType == 1) {
                sRatio = Math.min(xRatio, yRatio);
            }
            else if (scaleType == 2) {
                sRatio = Math.max(xRatio, yRatio);
            }
        }
        // store.setBookPageScale(iw / (w * sRatio), ih / (h * sRatio));
        this.scaleCanvas();
        domContainers[0].width = w * pRatio * sRatio;
        domContainers[0].height = h * pRatio * sRatio;
        domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
            PainterProxy.getInstance().updateViewportTransform();
        });

        stage.scaleX = pRatio * sRatio;
        stage.scaleY = pRatio * sRatio;

        lastW = iw; lastH = ih; lastS = sRatio;
        stage.tickOnUpdate = false;
        stage.update();
        stage.tickOnUpdate = true;

        if (typeof this.onStageResize == 'function') {
            this.onStageResize(xRatio, sRatio)
        }
    }

    updateCanvasScale() {
        var w, h;
        w = this.stageWidth;
        h = this.stageHeight;
        var iw = window.pageWidth, ih = window.pageHeight;
        console.log(`ih: ${ih} h: ${h}`)
        var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;

        sRatio = Math.min(xRatio, yRatio);
        if (settingStore.isFixed == 0) {
            store.setBookPageScale(ih / (h * sRatio), ih / (h * sRatio));
            console.log(`w: ${iw / (w * sRatio)} h: ${ih / (h * sRatio)}`)
        } else {
            store.setBookPageScale(iw / (w * sRatio), ih / (h * sRatio));
        }
    }

    scaleContainers(scale) {
        if (!this.pageStage) return;
        let i = 0;
        this.pageStage.tickOnUpdate = false;
        let lib = this.pageContainers[0].comp.getLibrary();

        let margin = (scale - 1) * lib.properties.width;
        this.pageStage.tickOnUpdate = false;

        for (i = 0; i < this.pageContainers.length; i++) {
            if (this.pageContainers[i].exportRoot) {
                this.pageContainers[i].exportRoot.scale = scale;
                this.pageContainers[i].exportRoot.x = i * lib.properties.width + i * margin;
            }
        }

        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }
    antialiasing() {
        if (enableAntialiasing.value == false) return;

        let lib = this.pageContainers[0].comp.getLibrary();
        let w = lib.properties.width * 2, h = lib.properties.height

        this.pageStage.update();
        this.pageStage.uncache();
        this.pageStage.tickOnUpdate = false;
        this.pageStage.filters = [new this.createjs.BlurFilter(1, 1, 1)];
        var bounds = this.pageStage.getBounds();
        Debugger.Instance.log({ 'bounds': bounds }, "page_loader");
        // this.pageStage.cache(bounds.x, bounds.y, Math.ceil(bounds.width) + 5, Math.ceil(bounds.height) + 5);
        this.pageStage.cache(0, 0, w, h);
        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }

    mutiAntialiasing() {
        if (enableAntialiasing.value == false) return;
        this.pageStage.uncache();
        this.pageStage.tickOnUpdate = false;
        this.pageStage.update();

        const self = this;

        this.itemControl.bookItems.forEach(item => {
            self.singleAntialiasing(item.target);
        });

        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }
    singleAntialiasing(target) {
        if (enableAntialiasing.value == false) return;
        // 檢查目標的父層是不是頁面，如果不是則需要反鋸齒整個群組
        let i = 0;
        let antialiasTarget = false;
        for (i = 0; i < this.pageContainers.length; i++) {
            if (target.parent == null) return;
            if (this.pageContainers[i].exportRoot.id == target.parent.id) {
                antialiasTarget = true;
                continue;
            }
        }
        if (antialiasTarget == false) {
            target.uncache();
            this.singleAntialiasing(target.parent);
            return;
        }
        target.uncache();
        this.pageStage.tickOnUpdate = false;
        target.filters = [new this.createjs.BlurFilter(1, 1, 1)];
        var bounds = target.getBounds();

        if (bounds != null) {
            target.cache(bounds.x, bounds.y, bounds.width, bounds.height);
            target.setBounds(bounds.x, bounds.y, bounds.width, bounds.height);
        }

        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }

    antialiasingObjects() {
        if (enableAntialiasing.value == false) return;
        if (this.antialiasingMovieClips.length == 0) {
            return;
        }
        this.pageStage.uncache();
        this.pageStage.tickOnUpdate = false;
        let i = 0;
        for (i = 0; i < this.antialiasingMovieClips.length; i++) {
            let target = this.antialiasingMovieClips[i];
            let bounds = target.getBounds();
            if (bounds != null && this.pageContainers[0].exportRoot.scale <= 2) {
                target.filters = [new this.createjs.BlurFilter(1, 1, 1)];
                target.cache(bounds.x, bounds.y, bounds.width, bounds.height);
                target.setBounds(bounds.x, bounds.y, bounds.width, bounds.height);
            } else {
                target.uncache();
                target.filters = [];
            }
        }
        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }
    pushMovieClipAntialiasing(target) {
        this.antialiasingMovieClips.push(target);
    }

    startMoveContainer(index) {
        this.moveTarget = this.pageContainers[index];
    }

    moveContainer(point) {
        let lib = this.pageContainers[0].comp.getLibrary();
        let w = lib.properties.width * 2, h = lib.properties.height;
        let scale = this.pageContainers[0].exportRoot.scale;
        let normalWidth = w * this.pageStage.scaleX * scale - this.pageCanvas.width;
        let left = (store.singlePageMode && store.singlePageIndex == 1)
            ? -normalWidth + (normalWidth * (scale - 2) / 2)
            : 0;
        let right = (store.singlePageMode && store.singlePageIndex == 0)
            ? (normalWidth) / (scale - 1) * (scale - 2) / 2
            : normalWidth;
        let bottom = h * this.pageStage.scaleY * scale - this.pageCanvas.height;

        this.pageStage.tickOnUpdate = false;
        this.pageStage.x += point.x;
        this.pageStage.y += point.y;

        if (this.pageStage.x >= left) {
            this.pageStage.x = left;
        }
        if (this.pageStage.x <= -right) {
            this.pageStage.x = -right;
        }

        if (this.pageStage.y >= 0) {
            this.pageStage.y = 0;
        }
        if (this.pageStage.y <= -bottom) {
            this.pageStage.y = -bottom;
        }
        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }


    /**
     *
     *
     * @param {*} point
     * @return {*} 
     * @memberof PageLoader
     */
    pointOnCanvas(point) {
        // console.log(`(${point.x} - ${this.pageStage.x}) * ${this.pageStage.scaleX} * ${this.pageContainers[0].exportRoot.scale}`)
        let newPoint = {
            x: (point.x - this.pageStage.x) * this.pageStage.scaleX * this.pageContainers[0].exportRoot.scale,
            y: (point.y - this.pageStage.y) * this.pageStage.scaleY * this.pageContainers[0].exportRoot.scale
        }

        return newPoint;
    }

    /**
     *
     *
     * @param {{x: number, y: number}} point
     * @return {{x: number, y: number}} point relative stage
     * @memberof PageLoader
     */
    pointOnStage(point) {
        let newPoint = {
            x: (point.x - this.pageStage.x),
            y: (point.y - this.pageStage.y)
        }

        return newPoint;
    }
    /**
     * set position of stage
     * @param {{x: Number, y: Number}}} point 
     */
    setStagePosition(point) {
        if (!this.pageStage) return;
        this.pageStage.tickOnUpdate = false;
        this.pageStage.x = point.x * window.devicePixelRatio;
        this.pageStage.y = point.y * window.devicePixelRatio;
        this.pageStage.update();
        this.pageStage.tickOnUpdate = true;
    }

    getScreenPoint(point) {
        let newPoint = {
            x: point.x / this.pageStage.scaleX / this.pageContainers[0].exportRoot.scale,
            y: point.y / this.pageStage.scaleY / this.pageContainers[0].exportRoot.scale
        }

        return newPoint;
    }

    pause() {
        this.pageStage.tickOnUpdate = false;
    }

    resume() {
        this.pageStage.tickOnUpdate = true;
    }
}